export function toCustomDate (date) {
  var dayString = '' + date.getDate()
  dayString = dayString.length === 1 ? '0' + dayString : dayString

  var monthString = '' + (date.getMonth() + 1)
  monthString = monthString.length === 1 ? '0' + monthString : monthString
  return '' + date.getFullYear() + monthString + dayString
}

export function toCustomDateLastDay (date) {
  var monthString = '' + (date.getMonth() + 1)
  monthString = monthString.length === 1 ? '0' + monthString : monthString

  var dayString

  if (date.getMonth() === (new Date()).getMonth() && date.getFullYear() === (new Date()).getFullYear()) {
    dayString = '' + date.getDate()
    dayString = dayString.length === 1 ? '0' + dayString : dayString
  } else {
    switch (date.getMonth()) {
      case 0:
      case 2:
      case 4:
      case 6:
      case 7:
      case 9:
      case 11:
        dayString = '' + 31
        break
      case 1:
        dayString = '' + 28
        break
      default:
        dayString = '' + 30
        break
    }
  }

  return '' + date.getFullYear() + monthString + dayString
}

export function toGetMonth (date) {
  let month = ''
  if (date.length === 8) {
    month = date.substr(4, 2)
  }
  else {
    month = ''
  }
  return month
}

export function toGetYear (date) {
  let year = ''
  if (date.length === 8) {
    year = date.substr(0, 4)
  }
  else {
    year = ''
  }
  return year
}



// WEBPACK FOOTER //
// ./src/utils/parsers.js